import { styled } from '@mui/material/styles';

export const LatencyIcon = styled('div')<{
  padding?: string;
  fontSize?: string;
  $clickable?: boolean;
}>`
  padding: ${({ padding }) => (padding ? padding : '4px 4px')};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white['06']};
  color: ${({ theme }) => theme.palette.white['01']};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
  font-weight: 500;
  height: 36px;
  width: 36px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  ${({ $clickable, theme }) =>
    $clickable &&
    `
    :hover {
      outline: 1px solid ${theme.palette.primary['01']};
    }
  `}
`;

export const IconPickerGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  max-width: 220px;
  margin-left: 8px;
  background: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? 'linear-gradient(145deg, rgba(42, 52, 77, 0.85) 0%, rgba(0, 207, 255, 0.12) 100%)'
      : 'rgba(255, 255, 255, 0.95)'};
  border: 1px solid ${({ theme }) => theme.palette.white['06']};
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
`;

export const IconOption = styled('button')<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  padding: 0;
  border-radius: 6px;
  border: 1px solid
    ${({ theme, $selected }) =>
      $selected ? 'transparent' : theme.palette.white['06']};
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.palette.white['06'] : 'transparent'};
  color: ${({ theme, $selected }) =>
    $selected ? theme.palette.white['01'] : theme.palette.white['06']};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.palette.white['01']};
  }
`;
